import Vue from 'vue'
import http from '@/utils/ajax'
import { BRANCHPARAM_INIT_LOADING, BRANCHPARAM_INIT_SUCCESS, BRANCHPARAM_INIT_FAIL, BRANCHPARAM_COUNTRYLIST, BRANCHPARAM_BANKLIST, BRANCHPARAM_GSTKEYBRNLIST, BRANCHPARAM_MAINFORM, BRANCHPARAM_NEWBRANCH, BRANCHPARAM_LEAVEQUOTE } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  init: 0,
  initErr: [],
  menu: {},
  countryList: [],
  bankList: [],
  gstKeyBrnList: [],
  mainform: {},
  newBranch: true,
  promptWhenExit: true
}

const getters = {

}

const mutations = {
  [BRANCHPARAM_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [BRANCHPARAM_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [BRANCHPARAM_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [BRANCHPARAM_COUNTRYLIST](state, data) {
    Vue.set(state, 'countryList', data)
  },
  [BRANCHPARAM_BANKLIST](state, data) {
    Vue.set(state, 'bankList', data)
  },
  [BRANCHPARAM_GSTKEYBRNLIST](state, data) {
    Vue.set(state, 'gstKeyBrnList', data)
  },
  [BRANCHPARAM_MAINFORM](state, data) {
    Vue.set(state, 'mainform', data)
  },
  [BRANCHPARAM_LEAVEQUOTE](state, data) {
    Vue.set(state, 'promptWhenExit', data)
  },
  [BRANCHPARAM_NEWBRANCH](state, data) {
    Vue.set(state, 'newBranch', data)
  }
}

const actions = {
  async branchManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.branchManagement
    commit(BRANCHPARAM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      let apiURL = commitResult.menu.countryList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(BRANCHPARAM_COUNTRYLIST, result.data.data.countryList)
        } catch (err) {
          throw err
        }
      }
      apiURL = commitResult.menu.bankList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(BRANCHPARAM_BANKLIST, result.data.data.bankList)
        } catch (err) {
          throw err
        }
      }
      apiURL = commitResult.menu.gstKeyBrnList

      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(BRANCHPARAM_GSTKEYBRNLIST, result.data.data.gstKeyBrnList)
        } catch (err) {
          throw err
        }
      }
      commit(BRANCHPARAM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(BRANCHPARAM_INIT_FAIL, extractMessages(error))
    }
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
